import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import LeftSideNavigation from "../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { ViewOpenIssuesTicketLeft } from "../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/ViewUsersTickets/ViewOpenIssuesTicketLeft";
import { ViewOpenIssuesTicketLeftMobile } from "../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/ViewUsersTickets/ViewOpenIssuesTicketLeftMobile";
import { ViewOpenIssuesTicketRight } from "../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/ViewUsersTickets/ViewOpenIssuesTicketRight";
import Media from "react-media";

import { OpenIssueRightSideView } from "./leftRightSection/OpenIssueRightSideView";
import { RightIssuesSuggestion } from "./leftRightSection/RightIssuesSuggestion";
import { LeftIssuesSuggestion } from "./leftRightSection/LeftIssuesSuggestion";
import { AmealioLoader } from "../../Loader/AmealioLoader";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import {
  get_only_one_issues_suggestions,
  comment_vendor_issues_suggestion,
} from "../../../store/actions/VendorIssuesSuggestionActions/VendorIssuesSuggestionActions";
import isEmpty from "../../../store/validation/is-Empty";

const VendorOpenIssuesSuggestionView = (props) => {
  //state
  const [showChat, setShowChat] = useState(false);
  const [showLog, setShowLog] = useState(true);
  const handleChatSHow = () => {
    setShowChat(true);
    setShowLog(false);
  };
  const handleLogSHow = () => {
    setShowLog(true);
    setShowChat(false);
  };

  let history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [issuesDetails, setIssuesDetails] = useState({});
  useEffect(() => {
    let issueId = location.state.issuesId;
    let token = props.auth.user.accessToken;
    dispatch(get_only_one_issues_suggestions(token, issueId));
  }, [location]);

  useEffect(() => {
    setIssuesDetails(props.singleIssues);
  }, [props.singleIssues]);

  const [message, setNewMessage] = useState({ message: "" });

  const onClickAddComment = () => {
    const token = props.auth.user.accessToken;
    const formData = {};
    formData.respond = message.message;
    dispatch(
      comment_vendor_issues_suggestion(
        formData,
        token,
        issuesDetails._id,
        clearMessage
      )
    );
  };

  const clearMessage = (e) => {
    setNewMessage({
      message: "",
    });
    let issuesId = issuesDetails._id;
    const token = props.auth.user.accessToken;
    dispatch(get_only_one_issues_suggestions(token, issuesId));
    setNewMessage({
      message: "",
    });
  };

  if (props.auth.loader) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <Media query="(min-width: 992px)">
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
            </Media>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel ">
              <Media query="(min-width: 992px)">
                <RightSideNavigation
                  leftText="vendorReview"
                  backButtonLink="/vendoropensuggestionissues"
                  displayText="Back"
                />
              </Media>

              <div className="row pb-3">
                <Col md={6} className="pt-4">
                  {/* <NavLink
                    to="/vendoropensuggestionissues"
                    className="f12-500 enBackLink"
                  >
                    <Image
                      fluid
                      alt="Back Icon"
                      title="Back Icon"
                      className="mr-2"
                      src={require("../../../assets/images/UserManagement/backIcon.svg")}
                    />
                    Back
                  </NavLink> */}
                  <Media query="(min-width: 992px)">
                    <div className="f24_700_HelveticaNeue">
                      Issue No : {issuesDetails && issuesDetails.issue_id}
                    </div>
                  </Media>
                </Col>
                <Col
                  md={6}
                  className="d-flex align-items-end justify-content-end"
                >
                  {showLog && (
                    <Button
                      variant="danger"
                      className="btn2 btn-lg"
                      onClick={handleChatSHow}
                    >
                      Submit Response
                    </Button>
                  )}
                  {showChat && (
                    <Button
                      variant="danger"
                      className="btn2 btn-lg"
                      onClick={handleLogSHow}
                    >
                      View Log
                    </Button>
                  )}
                </Col>
              </div>
              <div className="super-admin-inside-right-side-panel pt-4 pb-4">
                <div className="row">
                  <div className="col-lg-5 pr-lg-0">
                    <Media query="(min-width: 992px)">
                      <LeftIssuesSuggestion
                        issuesData={issuesDetails && issuesDetails}
                        token={props.auth.user.accessToken}
                      />
                    </Media>
                    <Media query="(max-width: 992px)">
                      <ViewOpenIssuesTicketLeftMobile />
                    </Media>
                  </div>
                  <div className="col-lg-7">
                    <OpenIssueRightSideView
                      message={message.message}
                      onChange={(e) =>
                        setNewMessage({
                          [e.target.name]: e.target.value,
                        })
                      }
                      onClickAddComment={(e) =>
                        onClickAddComment(message.message)
                      }
                      auth={props.auth}
                      logData={issuesDetails}
                      showLog={showLog}
                      showChat={showChat}
                      onClickShowLog={handleLogSHow}
                      handleChatSHow={handleChatSHow}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
};

VendorOpenIssuesSuggestionView.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  singleIssues: state.vendorIssuesSuggestion.vendor_single_issue_suggestion,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_only_one_issues_suggestions,
  comment_vendor_issues_suggestion,
})(withRouter(VendorOpenIssuesSuggestionView));

// import React, { Component } from "react";
// import moment from "moment";
// import SimpleReactLightbox from "simple-react-lightbox";
// import LeftSideNavigation from "../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
// import HomeReusableTopBarNavigation from "../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
// import { RightIssuesSuggestion } from "./leftRightSection/RightIssuesSuggestion";
// import { LeftIssuesSuggestion } from "./leftRightSection/LeftIssuesSuggestion";

// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
// import { clear_all_errors } from "../../../store/actions/errorActions";
// import { get_only_one_issues_suggestions } from "../../../store/actions/VendorIssuesSuggestionActions/VendorIssuesSuggestionActions";
// import isEmpty from "../../../store/validation/is-Empty";

// export class VendorOpenIssuesSuggestionView extends Component {
//   constructor(props) {
//     super();
//     this.state = {
//       allViewData: {},
//       category: {},
//       detailsProps: {},
//       comments: [],
//       contactDetails: "",
//       enquiryEmails: "",
//       displayChatScreen: false,
//     };
//   }

//   componentDidMount() {
//     const token = this.props.auth.user.accessToken;
//     const issuesId = !isEmpty(this.props.location.state.issuesId)
//       ? this.props.location.state.issuesId
//       : "";
//     if (!isEmpty(this.props.get_only_one_issues_suggestions)) {
//       this.props.get_only_one_issues_suggestions(token, issuesId);
//     }
//   }

//   static getDerivedStateFromProps(nextProps, nextState) {
//     if (!isEmpty(nextProps.singleIssues) !== nextState.allViewData) {
//       return {
//         allViewData: !isEmpty(nextProps.singleIssues)
//           ? nextProps.singleIssues
//           : {},
//         category: !isEmpty(nextProps.singleIssues.category)
//           ? nextProps.singleIssues.category
//           : "",
//         detailsProps: !isEmpty(nextProps.singleIssues.restaurant_id)
//           ? nextProps.singleIssues.restaurant_id
//           : {},
//         contactDetails: !isEmpty(nextProps.singleIssues.restaurant_id)
//           ? nextProps.singleIssues.restaurant_id.contact_detail[0]
//           : "",
//         enquiryEmails: !isEmpty(nextProps.singleIssues.restaurant_id)
//           ? nextProps.singleIssues.restaurant_id.enquiry_email[0]
//           : "",
//         comments: !isEmpty(nextProps.singleIssues.issue_comments)
//           ? nextProps.singleIssues.issue_comments
//           : [],
//       };
//     }
//     return null;
//   }

//   onChangeScreenChat = (e) => {
//     this.setState({
//       displayChatScreen: !this.state.displayChatScreen,
//     });
//   };

//   renderResolutionLogBody = () => {
//     const { allViewData } = this.state;
//     if (!isEmpty(allViewData)) {
//       return allViewData.resolution_logs.map((data, index) => (
//         <React.Fragment key={index}>
//           <tr>
//             <td>
//               <div>
//                 <h4>{moment(data.date).format("Do MMM YYYY")}</h4>
//                 <h4>{moment(data.date).format("hh:mm A")}</h4>
//               </div>
//             </td>
//             <td>{data.comment}</td>
//             <td>{data.initiator}</td>
//           </tr>
//         </React.Fragment>
//       ));
//     } else {
//       return null;
//     }
//   };

//   render() {
//     const {
//       allViewData,
//       category,
//       detailsProps,
//       contactDetails,
//       enquiryEmails,
//       comments,
//     } = this.state;
//     return (
//       <React.Fragment>
//         <div className="container-fluid">
//           <div className="row">
//             <div className="left-side-panel">
//               <LeftSideNavigation />
//             </div>
//             <div className="super-admin-right-side-panel">
//               <HomeReusableTopBarNavigation
//                 displayText={`Issue No: ${allViewData.issue_id}`}
//                 displayBack={true}
//                 backButtonLink="/vendoropensuggestionissues"
//               />
//               <div className="super-admin-inside-right-side-panel pt-4 pb-4">
//                 <div className="row">
//                   <div className="col-5">
//                     <SimpleReactLightbox>
//                       <LeftIssuesSuggestion
//                         issuesData={allViewData}
//                         restaurantData={detailsProps}
//                         emailData={enquiryEmails}
//                         contactDetails={contactDetails}
//                         category={category}
//                       />
//                     </SimpleReactLightbox>
//                   </div>
//                   <div className="col-7">
//                     <RightIssuesSuggestion
//                       sendDataProps={allViewData}
//                       displayInput={false}
//                       displayChatScreenFunc={this.onChangeScreenChat}
//                       displayChatScreen={this.state.displayChatScreen}
//                       tableBody={this.renderResolutionLogBody()}
//                       comment={comments}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </React.Fragment>
//     );
//   }
// }

// VendorOpenIssuesSuggestionView.propTypes = {
//   auth: PropTypes.object.isRequired,
//   errors: PropTypes.object.isRequired,
// };

// const mapStateToProps = (state) => ({
//   auth: state.auth,
//   errors: state.errors.errors,
//   singleIssues: state.vendorIssuesSuggestion.vendor_single_issue_suggestion,
// });

// export default connect(mapStateToProps, {
//   clear_all_errors,
//   get_only_one_issues_suggestions,
// })(withRouter(VendorOpenIssuesSuggestionView));
